import { userConstants, reservationConstants, planningConstants } from '../constants';
import { apiService } from '../services';
import { alertActions } from './alert.actions';
import { history } from '../helpers';
import { globalActions } from './global.actions';

export const userActions = {
  login,
  logout,
  register,
  clearRegistration,
  reset,
  clearReset,
  getAccount,
  editAccount,
  setEditAccount,
  patchAccount,
  getReservations,
  editReservation,
  setEditReservation,
  patchReservation,
  postReservation,
  deleteReservation,
  searchClients,
  loadPlanning,
  addReservation,
  setAddReservation
};

function login(username, password) {
  return dispatch => {
    dispatch(request({ username }));
    dispatch(globalActions.startLoading());

    apiService.login(username, password)
      .then(
        user => {
          dispatch(success(user));
          history.push('/');
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      ).then(() => dispatch(globalActions.stopLoading()));
  };

  function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
  function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
  function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
  apiService.logout();
  return { type: userConstants.LOGOUT };
}

function register(user) {
  return dispatch => {
    dispatch(request(user));
    dispatch(globalActions.startLoading());

    apiService.register(user)
      .then(
        user => {
          dispatch(success(user));
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      ).then(() => dispatch(globalActions.stopLoading()));
  };

  function request(user) { return { type: userConstants.REGISTER_REQUEST, user } }
  function success(user) { return { type: userConstants.REGISTER_SUCCESS, user } }
  function failure(error) { return { type: userConstants.REGISTER_FAILURE, error } }
}

function clearRegistration() {
  return { type: userConstants.REGISTER_CLEAR };
}

function reset(user) {
  return dispatch => {
    dispatch(request(user));
    dispatch(globalActions.startLoading());

    apiService.reset(user)
      .then(
        user => {
          dispatch(success(user));
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      ).then(() => dispatch(globalActions.stopLoading()));
  };

  function request(user) { return { type: userConstants.RESET_REQUEST, user } }
  function success(user) { return { type: userConstants.RESET_SUCCESS, user } }
  function failure(error) { return { type: userConstants.RESET_FAILURE, error } }
}

function clearReset() {
  return { type: userConstants.RESET_CLEAR };
}

function getAccount() {
  return dispatch => {
    dispatch(request());

    apiService.getAccount()
      .then(
        user => {
          dispatch(success(user));
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };

  function request() { return { type: userConstants.GETACCOUNT_REQUEST } }
  function success(account) { return { type: userConstants.GETACCOUNT_SUCCESS, account } }
  function failure(error) { return { type: userConstants.GETACCOUNT_FAILURE, error } }
}

function editAccount() {
  return { type: userConstants.EDITACCOUNT_SETUP }
}

function setEditAccount(account) {
  return { type: userConstants.EDITACCOUNT_SET, account }
}

function patchAccount(account) {
  return dispatch => {
    dispatch(request());
    dispatch(globalActions.startLoading());

    apiService.patchAccount(account)
      .then(
        account => {
          dispatch(success(account));
          dispatch(alertActions.success({ userPatched: true }));
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      ).then(() => dispatch(globalActions.stopLoading()));
  };

  function request() { return { type: userConstants.PATCHACCOUNT_REQUEST } }
  function success(account) { return { type: userConstants.PATCHACCOUNT_SUCCESS, account } }
  function failure(error) { return { type: userConstants.PATCHACCOUNT_FAILURE, error } }
}

function getReservations() {
  return dispatch => {
    dispatch(request());
    dispatch(globalActions.startLoading());

    apiService.getReservations()
      .then(
        reservations => {
          dispatch(success(reservations));
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      ).then(() => dispatch(globalActions.stopLoading()));
  };

  function request() { return { type: reservationConstants.GETRESERVATIONS_REQUEST } }
  function success(reservations) { return { type: reservationConstants.GETRESERVATIONS_SUCCESS, reservations } }
  function failure(error) { return { type: reservationConstants.GETRESERVATIONS_FAILURE, error } }
}

function editReservation(id) {
  return { type: reservationConstants.EDITRESERVATIONS_SETUP, id }
}

function setEditReservation(res) {
  return { type: reservationConstants.EDITRESERVATIONS_SET, res }
}

function patchReservation(res) {
  return dispatch => {
    dispatch(request());
    dispatch(globalActions.startLoading());

    const oldId = res.id;

    apiService.patchReservation(res.id, { nbCreneau: res.nbCreneau, clients: res.clients })
      .then(
        res => {
          history.push('/');
          dispatch(success(res, oldId));
          dispatch(alertActions.success({ reservationPatched: true }));
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      ).then(() => dispatch(globalActions.stopLoading()));
  };

  function request() { return { type: reservationConstants.PATCHRESERVATIONS_REQUEST } }
  function success(res, oldId) { return { type: reservationConstants.PATCHRESERVATIONS_SUCCESS, res, oldId } }
  function failure(error) { return { type: reservationConstants.PATCHRESERVATIONS_FAILURE, error } }
}

function addReservation(res) {
  return { type: reservationConstants.ADDRESERVATIONS_SETUP, res }
}

function setAddReservation(res) {
  return { type: reservationConstants.ADDRESERVATIONS_SET, res }
}

function postReservation(res) {
  return dispatch => {
    dispatch(request());
    dispatch(globalActions.startLoading());

    apiService.postReservation({ debut: res.debut, court: res.court, nbCreneau: res.nbCreneau, clients: res.clients })
      .then(
        res => {
          history.push('/');
          dispatch(success(res));
          dispatch(alertActions.success({ reservationCreated: true }));
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      ).then(() => dispatch(globalActions.stopLoading()));
  };

  function request() { return { type: reservationConstants.POSTRESERVATIONS_REQUEST } }
  function success(res) { return { type: reservationConstants.POSTRESERVATIONS_SUCCESS, res } }
  function failure(error) { return { type: reservationConstants.POSTRESERVATIONS_FAILURE, error } }
}

function deleteReservation(id) {
  return dispatch => {
    dispatch(request());
    dispatch(globalActions.startLoading());

    apiService.deleteReservation(id)
      .then(
        () => {
          dispatch(success(id));
          dispatch(alertActions.success({ reservationDeleted: true }));
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      ).then(() => dispatch(globalActions.stopLoading()));
  };

  function request() { return { type: reservationConstants.DELETERESERVATIONS_REQUEST } }
  function success(id) { return { type: reservationConstants.DELETERESERVATIONS_SUCCESS, id } }
  function failure(error) { return { type: reservationConstants.DELETERESERVATIONS_FAILURE, error } }
}

function searchClients(search, callback) {
  return dispatch => {
    dispatch(request());

    apiService.searchClients(search)
      .then(
        (res) => {
          callback(res.map(row => { return { key: row.id, label: row.nom }; }));
          dispatch(success(res));
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };

  function request() { return { type: reservationConstants.SEARCHCLIENTS_REQUEST } }
  function success(res) { return { type: reservationConstants.SEARCHCLIENTS_SUCCESS, res } }
  function failure(error) { return { type: reservationConstants.SEARCHCLIENTS_FAILURE, error } }
}

function loadPlanning(date) {
  return dispatch => {
    dispatch(request());
    dispatch(globalActions.startLoading());

    apiService.loadPlanning(date)
      .then(
        (res) => {
          dispatch(success(res));
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      ).then(() => dispatch(globalActions.stopLoading()));
  };

  function request() { return { type: planningConstants.LOADPLANNING_REQUEST } }
  function success(res) { return { type: planningConstants.LOADPLANNING_SUCCESS, res } }
  function failure(error) { return { type: planningConstants.LOADPLANNING_FAILURE, error } }
}
